import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { CityGeneralInformation } from "../../../shared/models/classes/Dashboard/cityData/city-general-information";
import { DashboardBizzDevService } from "../../../shared/services/dashboard-bizz-dev.service";
import { Location } from "@angular/common";

@Component({
    selector: "app-city-details",
    templateUrl: "./city-details.component.html",
    styleUrls: ["./city-details.component.scss"],
})
export class CityDetailsComponent implements OnInit {
    cityID: number;
    cityGeneralInformation: CityGeneralInformation;
    bankerEmail: string;

    displayedColumns = ["yearID", "dataType", "importDate"];
    dataSource;
    @ViewChild(MatSort)
    sort: MatSort;

    constructor(
        private dashboardService: DashboardBizzDevService,
        private route: ActivatedRoute,
        private router: Router,
        private location: Location
    ) {}

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.cityID = +params["id"];
            this.getCityDetails();
            this.getCityGeneralInformationsByID();
        });
    }

    getCityDetails() {
        this.dashboardService
            .getDataTypeByYear(this.cityID)
            .subscribe((value) => {
                this.dataSource = new MatTableDataSource(value);
                if (this.sort) {
                    this.dataSource.sort = this.sort;
                }
            });
    }

    getCityGeneralInformationsByID() {
        this.dashboardService
            .getCityGeneralInformationByID(this.cityID)
            .subscribe((value) => {
                this.cityGeneralInformation = value;
                if (this.cityGeneralInformation.licenceType != "-") {
                    this.getBankerData();
                }
            });
    }

    getBankerData() {
        this.dashboardService.getBankerData(this.cityID).subscribe((value) => {
            this.bankerEmail = value;
        });
    }
    loadBack() {
        this.location.back();
    }
}
